
import {initWebComponent} from "@/helpers/web-component-helper";
import {
    LayerInfoFilterSettingsApplyButtonComponent
} from "@/components/layer/info/filter/buttons/layer-info-filter-settings-apply-button-component";
import {
    LayerInfoFilterSettingsGeometryComponent
} from "@/components/layer/info/filter/settings/layer-info-filter-settings-geometry-component";
import {getActiveFilter} from "@/helpers/filter/filter-helper";
import {
    LayerInfoFilterSettingsListComponent
} from "@/components/layer/info/filter/settings/layer-info-filter-settings-list-component";
import {
    LayerInfoFilterSettingsItemComponent
} from "@/components/layer/info/filter/settings/layer-info-filter-settings-item-component";
import {
    LayerInfoFilterSettingsTextComponent
} from "@/components/layer/info/filter/settings/layer-info-filter-settings-text-component";
import {
    LayerInfoFilterSettingsNumericBetweenComponent
} from "@/components/layer/info/filter/settings/layer-info-filter-settings-numeric-between-component";
import {
    LayerInfoFilterSettingsListMultiComponent
} from "@/components/layer/info/filter/settings/layer-info-filter-settings-list-multi-component";
import {
    LayerInfoFilterSettingsDateComponent
} from "@/components/layer/info/filter/settings/layer-info-filter-settings-date-component";
import {
    LayerInfoFilterSettingsResetButtonComponent
} from "@/components/layer/info/filter/buttons/layer-info-filter-settings-reset-button-component";
import {activateLayer, addLayer} from "@/helpers/ol/ol-layer-helper";
import {addLayerActive, removeLayerActive} from "@/helpers/ol/ol-layer-active-helper";
import {setMutationGeometryName} from "@/helpers/tools/tools-mutation-helper";
import {getKVLayerByBookmarkPresentationID} from "@/helpers/kv/kv-layer-helper";

export class LayerInfoFilterSettingsComponent extends HTMLElement {
    constructor(){
        super();

        const activeFilter = getActiveFilter()

        console.log(activeFilter)

        activateLayer(activeFilter.BookmarkPresentationID)

        const template = document.createElement('template');
        let innerHTML = `
     <div id="accordion">`

        activeFilter.form.form_attributes.map((formAttribute, key) => {
            const attribute = formAttribute.attribute

            if(formAttribute.AttributeTypeID !== 1001 || attribute.Type === 21) {

                console.log(formAttribute)

                let isRequired = ''
                if(formAttribute.IsRequired) {
                    isRequired = '<span class="fa fa-asterisk fa-mandatory"></span>'
                }

                innerHTML += `    
                 <div class="card card-info m-2">
                   <div class="card-header p-0" data-attribute="${formAttribute.attribute.Attribute}" data-header-key="${key}">
                      <a href="#" data-bs-toggle="collapse" data-bs-target="#collapse` + key + `" class="font-weight-bold text-dark accordion-header d-block p-2" aria-expanded="false" aria-controls="collapse` + key + `">
                        ${formAttribute.attribute.Display}${isRequired}
                        <div class="collapse-icon float-right"></div>
                        <layer-info-filter-settings-badge></layer-info-filter-settings-badge>
                      </a>
                    </div>
                    <div id="collapse` + key + `" data-bs-parent="#accordion" class="pb-2 pt-2 collapse" style="">
                        <div class="card-body text-secondary pl-2 pr-2">
                            <layer-info-filter-settings-item data-key="` + key + `"></layer-info-filter-settings-item>
                        </div>
                    </div>
                </div>`
            }
        })

    innerHTML += `      
     </div>
         <div class="card-footer font-weight-bold p-2">
             <div class="row">
                <div class="col-8">
                    <layer-info-filter-settings-apply-button></layer-info-filter-settings-apply-button>
                </div>
                <div class="col-4">
                    <layer-info-filter-settings-reset-button></layer-info-filter-settings-reset-button>
                </div>
             </div>
    </div>
`;

        const geometryAttribute = activeFilter.form.form_attributes.find( attribute => attribute.attribute.Type === 21)
        if(geometryAttribute) {
            window.filter_geom_column = geometryAttribute.attribute.Attribute
        }

        template.innerHTML = innerHTML

        initWebComponent(this, template)
    }
}

window.customElements.define("layer-info-filter-settings-apply-button", LayerInfoFilterSettingsApplyButtonComponent);
window.customElements.define("layer-info-filter-settings-reset-button", LayerInfoFilterSettingsResetButtonComponent);
window.customElements.define("layer-info-filter-settings-geometry", LayerInfoFilterSettingsGeometryComponent);
window.customElements.define("layer-info-filter-settings-list", LayerInfoFilterSettingsListComponent);
window.customElements.define("layer-info-filter-settings-list-multi", LayerInfoFilterSettingsListMultiComponent);
window.customElements.define("layer-info-filter-settings-item", LayerInfoFilterSettingsItemComponent);
window.customElements.define("layer-info-filter-settings-text", LayerInfoFilterSettingsTextComponent);
window.customElements.define("layer-info-filter-settings-numeric-between", LayerInfoFilterSettingsNumericBetweenComponent);
window.customElements.define("layer-info-filter-settings-date", LayerInfoFilterSettingsDateComponent);
